import React, { Component } from 'react';
import Button from '@material-ui/core/Button';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';

import { withStyles } from '@material-ui/core/styles';

import CircularProgress from '@material-ui/core/CircularProgress';

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

import TextField from '@material-ui/core/TextField';
import {observable, reaction} from 'mobx'
import { inject, observer } from 'mobx-react';
import {pending, error, done} from '../stores/State'

@inject('store')
@observer
class AddCustomerUser extends Component {
  @observable username = '';
  
  componentDidMount(){
    const store = this.props.store.customerStore;
    //store.createCustomerUserClear();
  }

  componentWillReceiveProps(nextProps){
    const store = nextProps.store.customerStore;
    //When opened, clear existing result  
    //if(nextProps.open && this.props.open !== nextProps.open) store.createCustomerUserClear();
  }

  create(){
    const store = this.props.store.customerStore; 
    store.customer.createUser(this.username)
  }

  render() {
    const { classes, open, handleClose } = this.props;
    const store = this.props.store.customerStore; 
    
    return (
      <Dialog open={open} onClose={handleClose}>
          <DialogTitle>Create new user</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Create new user for this customer. The new user can create inventory locations and inventory transactions for this customer.
            </DialogContentText>
            <TextField
              autoFocus
              id="email"
              label="Email"
              type="email"
              fullWidth
              value={this.username}
              onChange={(event)=>this.username = event.target.value}              
            />
            <DialogContentText>
              User will need to activate the account using a link sent to the email address
            </DialogContentText>
              { store.customer.createUserState === pending && <CircularProgress />}
              { store.customer.createUserState === error && <Typography color='error' type="body1">Creating user failed!</Typography>}
              { store.customer.createUserError && store.customer.createUserError.response.data.username && <Typography color='error' type="body1">User with this email already exists</Typography>}
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color="primary">
              Cancel
            </Button>
            <Button disabled={store.customer.createUserState == pending} onClick={()=>this.create()} color="primary">
              Create
            </Button>
          </DialogActions>
        </Dialog>
    );
  }
}

const styles = theme => ({

});

AddCustomerUser.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.func,
}

export default withStyles(styles)(AddCustomerUser);



// WEBPACK FOOTER //
// ./src/components/AddCustomerUser.js